/*
convert CSV -> JSON (from Sodex Onboarding google sheet) then below function maps
_.map(json, q => { return { legacyId: q.ItemBankID, categoryId: q.CategoryID > 0 ? q.CategoryID : null, dimensionId: q.DimensionID, text: q.item, reverseScore: q.ScoreDirection === 'FALSE' ? true : false,  } });

qs (questions)
ls (localizations from csv sent by courtney)

let mqs = {};

_.each(qs, q => {
  const matchingL = _.find(ls, {ItemID: q.legacyId});

  if(matchingL){
    mqs[q.id] = {
      ...q,
      localizations: {
        fr: matchingL['Item French (EU)'],
        de: matchingL['Item German'],
        es: matchingL['Item Spanish (EU)'],
        pt: matchingL['Item Portuguese (EU)'],
        zh: matchingL['Item Chinese (SIMP)'],
        sv: matchingL['Item Swedish'],
        cs: matchingL['Item Czech'],
        hu: matchingL['Item Hungarian'],
        pl: matchingL['Item Polish'],
        ro: matchingL['Item Romanian'],
        nl: matchingL['Item Dutch'],
        tr: matchingL['Item Turkish'],
      }
    }
  }
  else{
    mqs[q.id] = {
      ...q,
    }
  }

});

*/

/*
Example localizations

localizations: {
  default: {
    questions: {
      r39u6m: null,
      23k9x9: null,
    }
  },
  fr: {
    questions: {
      r39u6m: 'ASDF',
      23k9x9: ...
    }
  }
}


_.each(questions, question => {
	mappedQuestions[question.id] = {
		id: question.id,
		questionFormat: question.questionFormat,
		questionType: question.questionType === 'talent' ? 'talent' : 'skill',
		legacyId: question.legacyId,
		categoryId: question.categoryId,
		scoredDimensions: {
			[question.dimensionId]: true
        },
		reverseScore: question.reverseScore || false,
		questionIndex: question.questionIndex,
		text: question.text,
		status: (!question.visible ? 'disabled' : ( question.experimental ? 'experimental' : 'live' )),

	}
});

*/

export const questions = {
  "kwu01w": {
    "id": "kwu01w",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1129,
    "categoryId": 1,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": false,
    "questionIndex": 1,
    "text": "I teach customers how to deliver value and manage risk through our company's solutions.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "uadhhn": {
    "id": "uadhhn",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1,
    "categoryId": 1,
    "scoredDimensions": [
      "vjtt0z",
      "ceokld"
    ],
    "reverseScore": false,
    "questionIndex": 2,
    "text": "I work much harder than most people.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "nuyeet": {
    "id": "nuyeet",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 6,
    "categoryId": 1,
    "scoredDimensions": [
      "oyzo55"
    ],
    "reverseScore": false,
    "questionIndex": 3,
    "text": "I can't stand waiting when I am ready to go.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "fll4h8": {
    "id": "fll4h8",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 11,
    "categoryId": 1,
    "scoredDimensions": [
      "jctmmw"
    ],
    "reverseScore": true,
    "questionIndex": 4,
    "text": "I hate having a lot of things going on at the same time.",
    "status": "live",
    "dimensionFamily": "bfbovn"
  },
  "wnt365": {
    "id": "wnt365",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 13,
    "categoryId": 1,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": false,
    "questionIndex": 5,
    "text": "I feel bad about myself when the day goes by and I haven't gotten a lot accomplished.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "e8gtyz": {
    "id": "e8gtyz",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 21,
    "categoryId": 1,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 6,
    "text": "I feel physically ill when I lose.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "joqdsy": {
    "id": "joqdsy",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 31,
    "categoryId": 1,
    "scoredDimensions": [
      "p0ruta"
    ],
    "reverseScore": true,
    "questionIndex": 7,
    "text": "I will only work hard when the payoff is worth it.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "u9j9fa": {
    "id": "u9j9fa",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 36,
    "categoryId": 1,
    "scoredDimensions": [
      "xy680l"
    ],
    "reverseScore": true,
    "questionIndex": 8,
    "text": "I sometimes worry that others think I'm not good enough.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "yccj4q": {
    "id": "yccj4q",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 44,
    "categoryId": 1,
    "scoredDimensions": [
      "enzx1e"
    ],
    "reverseScore": false,
    "questionIndex": 9,
    "text": "My productivity and achievements rank among the top five percent of my peers.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "sjhv76": {
    "id": "sjhv76",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 47,
    "categoryId": 1,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 10,
    "text": "My team knows that I am exceptional at selling.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "i3rej3": {
    "id": "i3rej3",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 48,
    "categoryId": 1,
    "scoredDimensions": [
      "vjtt0z"
    ],
    "reverseScore": false,
    "questionIndex": 11,
    "text": "I often feel like I'm more talented than those I report to.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "vtzmjx": {
    "id": "vtzmjx",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 50,
    "categoryId": 1,
    "scoredDimensions": [
      "t9sjaz"
    ],
    "reverseScore": true,
    "questionIndex": 12,
    "text": "Smart, ambitious people intimidate me.",
    "status": "live",
    "dimensionFamily": "wbxc32"
  },
  "skx5py": {
    "id": "skx5py",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 53,
    "categoryId": 1,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": false,
    "questionIndex": 13,
    "text": "I believe that I will succeed in the end.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "aip7gi": {
    "id": "aip7gi",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 57,
    "categoryId": 1,
    "scoredDimensions": [
      "p0ruta"
    ],
    "reverseScore": false,
    "questionIndex": 14,
    "text": "I am rarely proven wrong.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "evxon7": {
    "id": "evxon7",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 58,
    "categoryId": 1,
    "scoredDimensions": [
      "xy680l"
    ],
    "reverseScore": true,
    "questionIndex": 15,
    "text": "I avoid speaking in front of a large audience.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "ui0sha": {
    "id": "ui0sha",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 59,
    "categoryId": 1,
    "scoredDimensions": [
      "y93iyg"
    ],
    "reverseScore": false,
    "questionIndex": 16,
    "text": "I see the possibilities in every situation.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "am1wyl": {
    "id": "am1wyl",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 65,
    "categoryId": 4,
    "scoredDimensions": [
      "jrsl97"
    ],
    "reverseScore": true,
    "questionIndex": 17,
    "text": "My obligation to fulfill a commitment depends upon the situation.",
    "status": "live",
    "dimensionFamily": "krqa3d"
  },
  "ubao7f": {
    "id": "ubao7f",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 68,
    "categoryId": 4,
    "scoredDimensions": [
      "ltu5rt"
    ],
    "reverseScore": false,
    "questionIndex": 18,
    "text": "I always do what I say I will do.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "bwgwh2": {
    "id": "bwgwh2",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 69,
    "categoryId": 4,
    "scoredDimensions": [
      "ltu5rt"
    ],
    "reverseScore": false,
    "questionIndex": 19,
    "text": "I feel tremendous guilt when I disappoint others.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "n7sio8": {
    "id": "n7sio8",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 72,
    "categoryId": 4,
    "scoredDimensions": [
      "eb2x38"
    ],
    "reverseScore": false,
    "questionIndex": 20,
    "text": "I have earned my clients' trust through consistently delivering.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "ld4bve": {
    "id": "ld4bve",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 74,
    "categoryId": 4,
    "scoredDimensions": [
      "fdwtt7"
    ],
    "reverseScore": false,
    "questionIndex": 21,
    "text": "I often choose to work late to avoid the risk of missing a deadline.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "h8vo2e": {
    "id": "h8vo2e",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 76,
    "categoryId": 4,
    "scoredDimensions": [
      "g5ii0e"
    ],
    "reverseScore": true,
    "questionIndex": 22,
    "text": "I don't like to have people depending on me.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "mt0axb": {
    "id": "mt0axb",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 77,
    "categoryId": 4,
    "scoredDimensions": [
      "ltu5rt"
    ],
    "reverseScore": false,
    "questionIndex": 23,
    "text": "I am more reliable than most people.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "hbh0pc": {
    "id": "hbh0pc",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 79,
    "categoryId": 4,
    "scoredDimensions": [
      "c54tc9"
    ],
    "reverseScore": true,
    "questionIndex": 24,
    "text": "I believe most people will cheat if they think they won't get caught.",
    "status": "live",
    "dimensionFamily": "ybx7l1"
  },
  "hjfctz": {
    "id": "hjfctz",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 89,
    "categoryId": 4,
    "scoredDimensions": [
      "x3ycav"
    ],
    "reverseScore": false,
    "questionIndex": 25,
    "text": "I need to have a place for everything and everything in its place.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "omiknj": {
    "id": "omiknj",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 91,
    "categoryId": 4,
    "scoredDimensions": [
      "wnyg5q"
    ],
    "reverseScore": false,
    "questionIndex": 26,
    "text": "I like to spend my free time planning how I will hit my goals.",
    "status": "live",
    "dimensionFamily": "ybx7l1"
  },
  "aja7p0": {
    "id": "aja7p0",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 92,
    "categoryId": 4,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 27,
    "text": "It really bothers me when I don't have a plan.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "mqrlfa": {
    "id": "mqrlfa",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 93,
    "categoryId": 4,
    "scoredDimensions": [
      "d22k6w"
    ],
    "reverseScore": true,
    "questionIndex": 28,
    "text": "I sometimes find it difficult to plan my time to complete my work.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "sf3e59": {
    "id": "sf3e59",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 95,
    "categoryId": 4,
    "scoredDimensions": [
      "g5ii0e"
    ],
    "reverseScore": false,
    "questionIndex": 29,
    "text": "I always arrive early for scheduled appointments.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "j2ay58": {
    "id": "j2ay58",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 96,
    "categoryId": 4,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 30,
    "text": "I set realistic time expectations to get work done.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "ll07jr": {
    "id": "ll07jr",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 103,
    "categoryId": 4,
    "scoredDimensions": [
      "oyzo55"
    ],
    "reverseScore": false,
    "questionIndex": 31,
    "text": "Others call me a perfectionist.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "rh66oi": {
    "id": "rh66oi",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 108,
    "categoryId": 4,
    "scoredDimensions": [
      "zavm2z"
    ],
    "reverseScore": false,
    "questionIndex": 32,
    "text": "I can't stand to leave things unfinished.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "dozfmu": {
    "id": "dozfmu",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 113,
    "categoryId": 4,
    "scoredDimensions": [
      "d22k6w"
    ],
    "reverseScore": false,
    "questionIndex": 33,
    "text": "I am not satisfied until the entire project is complete.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "xph4uj": {
    "id": "xph4uj",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 115,
    "categoryId": 4,
    "scoredDimensions": [
      "eb2x38"
    ],
    "reverseScore": true,
    "questionIndex": 34,
    "text": "Administrative systems to track sales activity are annoying.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "z0vavq": {
    "id": "z0vavq",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 122,
    "categoryId": 2,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": true,
    "questionIndex": 35,
    "text": "I am typically a bit reserved until I get to know a person.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "tz4bed": {
    "id": "tz4bed",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 136,
    "categoryId": 2,
    "scoredDimensions": [
      "vjtt0z"
    ],
    "reverseScore": false,
    "questionIndex": 36,
    "text": "My network makes me more valuable than others in my field.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "i1oxsk": {
    "id": "i1oxsk",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 137,
    "categoryId": 2,
    "scoredDimensions": [
      "g5ii0e"
    ],
    "reverseScore": false,
    "questionIndex": 37,
    "text": "I often tell jokes and stories in a social setting.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "pju4v6": {
    "id": "pju4v6",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 141,
    "categoryId": 2,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 38,
    "text": "I'm good at making others laugh.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "s93e28": {
    "id": "s93e28",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 144,
    "categoryId": 2,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 39,
    "text": "I have a talent for making people feel good about themselves.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "ftips8": {
    "id": "ftips8",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 145,
    "categoryId": 2,
    "scoredDimensions": [
      "p0ruta"
    ],
    "reverseScore": true,
    "questionIndex": 40,
    "text": "I have a hard time remembering names.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "h4jwyp": {
    "id": "h4jwyp",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 150,
    "categoryId": 2,
    "scoredDimensions": [
      "ep6tj6"
    ],
    "reverseScore": true,
    "questionIndex": 41,
    "text": "To win new business, I deliver a standard sales pitch that I have polished.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "etwkei": {
    "id": "etwkei",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 153,
    "categoryId": 2,
    "scoredDimensions": [
      "qsptzl"
    ],
    "reverseScore": false,
    "questionIndex": 42,
    "text": "It's easy for me to sense how people are feeling.",
    "status": "live",
    "dimensionFamily": "zx6iaq"
  },
  "acxn9n": {
    "id": "acxn9n",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 155,
    "categoryId": 2,
    "scoredDimensions": [
      "enzx1e"
    ],
    "reverseScore": false,
    "questionIndex": 43,
    "text": "I am good at figuring people out.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "iqw25m": {
    "id": "iqw25m",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 157,
    "categoryId": 2,
    "scoredDimensions": [
      "xy680l"
    ],
    "reverseScore": false,
    "questionIndex": 44,
    "text": "Others tell me that I am a good listener.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "iuchi8": {
    "id": "iuchi8",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 158,
    "categoryId": 2,
    "scoredDimensions": [
      "oyzo55"
    ],
    "reverseScore": false,
    "questionIndex": 45,
    "text": "My associates and clients know that I care about them.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "xeapl6": {
    "id": "xeapl6",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 163,
    "categoryId": 2,
    "scoredDimensions": [
      "b0e6f1"
    ],
    "reverseScore": true,
    "questionIndex": 46,
    "text": "In a sales meeting, I am careful to always treat everyone the same.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "s3azey": {
    "id": "s3azey",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 170,
    "categoryId": 2,
    "scoredDimensions": [
      "xmstja"
    ],
    "reverseScore": false,
    "questionIndex": 47,
    "text": "People often tell me about their personal problems.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "fbqx7o": {
    "id": "fbqx7o",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 172,
    "categoryId": 2,
    "scoredDimensions": [
      "xy680l"
    ],
    "reverseScore": true,
    "questionIndex": 48,
    "text": "I sell a universal value proposition that works for every audience.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "qqovgf": {
    "id": "qqovgf",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 175,
    "categoryId": 3,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 49,
    "text": "I tend to simplify a situation when I interpret it.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "uu9kg7": {
    "id": "uu9kg7",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 177,
    "categoryId": 3,
    "scoredDimensions": [
      "zbij77"
    ],
    "reverseScore": false,
    "questionIndex": 50,
    "text": "Others have told me that I am a quick study.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "jx6ani": {
    "id": "jx6ani",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 178,
    "categoryId": 3,
    "scoredDimensions": [
      "wnyg5q"
    ],
    "reverseScore": false,
    "questionIndex": 51,
    "text": "I am good at positioning a message to get my point across.",
    "status": "live",
    "dimensionFamily": "ybx7l1"
  },
  "k1z6j3": {
    "id": "k1z6j3",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 183,
    "categoryId": 3,
    "scoredDimensions": [
      "x47kw5"
    ],
    "reverseScore": false,
    "questionIndex": 52,
    "text": "I regularly read and track what's happening in my industry.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "pncx5v": {
    "id": "pncx5v",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 185,
    "categoryId": 3,
    "scoredDimensions": [
      "xmstja"
    ],
    "reverseScore": true,
    "questionIndex": 53,
    "text": "I need lots of repetition to gain competency.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "ih1pd4": {
    "id": "ih1pd4",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 187,
    "categoryId": 3,
    "scoredDimensions": [
      "jctmmw"
    ],
    "reverseScore": true,
    "questionIndex": 54,
    "text": "I sometimes make things more complex than they need to be.",
    "status": "live",
    "dimensionFamily": "bfbovn"
  },
  "xul2dm": {
    "id": "xul2dm",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 188,
    "categoryId": 3,
    "scoredDimensions": [
      "itypp1"
    ],
    "reverseScore": false,
    "questionIndex": 55,
    "text": "I make sure I am well informed before I go into a meeting.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "z09hst": {
    "id": "z09hst",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 190,
    "categoryId": 3,
    "scoredDimensions": [
      "x47kw5"
    ],
    "reverseScore": false,
    "questionIndex": 56,
    "text": "I find out what I need to know to be successful.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "vl7gk7": {
    "id": "vl7gk7",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 192,
    "categoryId": 3,
    "scoredDimensions": [
      "oyzo55"
    ],
    "reverseScore": false,
    "questionIndex": 57,
    "text": "I have become the go-to resource for my team to get competitive information.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "febxgj": {
    "id": "febxgj",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 194,
    "categoryId": 3,
    "scoredDimensions": [
      "itypp1"
    ],
    "reverseScore": false,
    "questionIndex": 58,
    "text": "I can easily pick out patterns in data.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "y126tm": {
    "id": "y126tm",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 198,
    "categoryId": 3,
    "scoredDimensions": [
      "xmstja"
    ],
    "reverseScore": false,
    "questionIndex": 59,
    "text": "I anticipate what a client will need, so it's clear what I need to do.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "lwz3tx": {
    "id": "lwz3tx",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 199,
    "categoryId": 3,
    "scoredDimensions": [
      "b0e6f1"
    ],
    "reverseScore": false,
    "questionIndex": 60,
    "text": "I tend to use analogies to help illustrate a point.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "ouhc52": {
    "id": "ouhc52",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 200,
    "categoryId": 3,
    "scoredDimensions": [
      "c54tc9"
    ],
    "reverseScore": false,
    "questionIndex": 61,
    "text": "I review trends in data when making important decisions.",
    "status": "live",
    "dimensionFamily": "ybx7l1"
  },
  "rmklza": {
    "id": "rmklza",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 205,
    "categoryId": 3,
    "scoredDimensions": [
      "x3ycav"
    ],
    "reverseScore": true,
    "questionIndex": 62,
    "text": "I never overthink things.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "n4qwu3": {
    "id": "n4qwu3",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 214,
    "categoryId": 4,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": true,
    "questionIndex": 63,
    "text": "I'm known for changing my mind frequently.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "oc6pkd": {
    "id": "oc6pkd",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 215,
    "categoryId": 4,
    "scoredDimensions": [
      "t9sjaz"
    ],
    "reverseScore": false,
    "questionIndex": 64,
    "text": "People know what to expect with me.",
    "status": "live",
    "dimensionFamily": "wbxc32"
  },
  "bcuwve": {
    "id": "bcuwve",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 218,
    "categoryId": 4,
    "scoredDimensions": [
      "d22k6w"
    ],
    "reverseScore": false,
    "questionIndex": 65,
    "text": "I often think about my sales goals when I am not working.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "v9zry7": {
    "id": "v9zry7",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 220,
    "categoryId": 4,
    "scoredDimensions": [
      "ep6tj6"
    ],
    "reverseScore": true,
    "questionIndex": 66,
    "text": "It's hard for me to focus when there's a lot going on.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "tkdscs": {
    "id": "tkdscs",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 223,
    "categoryId": 4,
    "scoredDimensions": [
      "g5ii0e"
    ],
    "reverseScore": false,
    "questionIndex": 67,
    "text": "I provide clarity for others in the midst of chaos.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "aotwxw": {
    "id": "aotwxw",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 229,
    "categoryId": 4,
    "scoredDimensions": [
      "jrsl97"
    ],
    "reverseScore": false,
    "questionIndex": 68,
    "text": "My friends and associates look to me for direction.",
    "status": "live",
    "dimensionFamily": "krqa3d"
  },
  "o9kf1t": {
    "id": "o9kf1t",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 230,
    "categoryId": 4,
    "scoredDimensions": [
      "t9sjaz"
    ],
    "reverseScore": false,
    "questionIndex": 69,
    "text": "Every day, I prioritize my work activity to reach my goals.",
    "status": "live",
    "dimensionFamily": "wbxc32"
  },
  "jyyv4t": {
    "id": "jyyv4t",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 234,
    "categoryId": 2,
    "scoredDimensions": [
      "ceokld"
    ],
    "reverseScore": false,
    "questionIndex": 70,
    "text": "I am a good teacher.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "upwxgq": {
    "id": "upwxgq",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 235,
    "categoryId": 2,
    "scoredDimensions": [
      "up7jjs"
    ],
    "reverseScore": true,
    "questionIndex": 71,
    "text": "I tend to confuse people who are slow learners.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "bj48yn": {
    "id": "bj48yn",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 236,
    "categoryId": 2,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 72,
    "text": "People stick with me because they know I look out for their best interests.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "hdpn14": {
    "id": "hdpn14",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 238,
    "categoryId": 2,
    "scoredDimensions": [
      "y93iyg"
    ],
    "reverseScore": false,
    "questionIndex": 73,
    "text": "I measure my success based upon the success of those I have developed.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "bzpz70": {
    "id": "bzpz70",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 239,
    "categoryId": 2,
    "scoredDimensions": [
      "ltu5rt"
    ],
    "reverseScore": false,
    "questionIndex": 74,
    "text": "I have helped someone improve their performance in the last seven days.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "crxd7e": {
    "id": "crxd7e",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 241,
    "categoryId": 2,
    "scoredDimensions": [
      "ep6tj6"
    ],
    "reverseScore": true,
    "questionIndex": 75,
    "text": "I advise others how to do things my way.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "v73dhl": {
    "id": "v73dhl",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 243,
    "categoryId": 2,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 76,
    "text": "I am good at helping others see what they can accomplish.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "lwpzyg": {
    "id": "lwpzyg",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 248,
    "categoryId": 2,
    "scoredDimensions": [
      "up7jjs"
    ],
    "reverseScore": false,
    "questionIndex": 77,
    "text": "People I work with know that my feedback is well intended.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "a03e8j": {
    "id": "a03e8j",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 249,
    "categoryId": 2,
    "scoredDimensions": [
      "oyzo55"
    ],
    "reverseScore": false,
    "questionIndex": 78,
    "text": "I talk to people about the potential I see in them.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "vl2l0p": {
    "id": "vl2l0p",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 250,
    "categoryId": 4,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": true,
    "questionIndex": 79,
    "text": "I avoid conflict.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "nbtcr8": {
    "id": "nbtcr8",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 258,
    "categoryId": 4,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 80,
    "text": "I tend to be a little pushy.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "y448u0": {
    "id": "y448u0",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 260,
    "categoryId": 4,
    "scoredDimensions": [
      "x3ycav"
    ],
    "reverseScore": true,
    "questionIndex": 81,
    "text": "I don't ask for business when I think it may make my client uncomfortable.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "hcp98u": {
    "id": "hcp98u",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 261,
    "categoryId": 4,
    "scoredDimensions": [
      "ep6tj6"
    ],
    "reverseScore": false,
    "questionIndex": 82,
    "text": "When going out with friends, I usually decide what we are going to do.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "p102aq": {
    "id": "p102aq",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 264,
    "categoryId": 4,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": true,
    "questionIndex": 83,
    "text": "I only invest time if a prospect communicates interest in the product I am selling.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "vzmcq4": {
    "id": "vzmcq4",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 265,
    "categoryId": 4,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 84,
    "text": "Others know I will stand up for them in the face of resistance.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "tqhi09": {
    "id": "tqhi09",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 267,
    "categoryId": 4,
    "scoredDimensions": [
      "ep6tj6"
    ],
    "reverseScore": false,
    "questionIndex": 85,
    "text": "I persuade people to do things they did not initially intend to do.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "ooxooi": {
    "id": "ooxooi",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 271,
    "categoryId": 1,
    "scoredDimensions": [
      "vjtt0z"
    ],
    "reverseScore": false,
    "questionIndex": 86,
    "text": "Lazy people really annoy me.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "tc5boc": {
    "id": "tc5boc",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 276,
    "categoryId": 1,
    "scoredDimensions": [
      "u0uvji"
    ],
    "reverseScore": false,
    "questionIndex": 87,
    "text": "I am willing to sacrifice more than most to succeed.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "icb9ng": {
    "id": "icb9ng",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 281,
    "categoryId": 1,
    "scoredDimensions": [
      "ltu5rt"
    ],
    "reverseScore": false,
    "questionIndex": 88,
    "text": "I have more energy than most people.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "v1tss9": {
    "id": "v1tss9",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 282,
    "categoryId": 1,
    "scoredDimensions": [
      "ep6tj6"
    ],
    "reverseScore": false,
    "questionIndex": 89,
    "text": "I often continue to work on a deal when others give up.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "o0ixzx": {
    "id": "o0ixzx",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 286,
    "categoryId": 1,
    "scoredDimensions": [
      "u0uvji"
    ],
    "reverseScore": true,
    "questionIndex": 90,
    "text": "I patiently wait for opportunities to come my way.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "vki7q6": {
    "id": "vki7q6",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 291,
    "categoryId": 2,
    "scoredDimensions": [
      "t9sjaz"
    ],
    "reverseScore": true,
    "questionIndex": 91,
    "text": "Clients typically have unreasonable expectations.",
    "status": "live",
    "dimensionFamily": "wbxc32"
  },
  "khjv8a": {
    "id": "khjv8a",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 292,
    "categoryId": 2,
    "scoredDimensions": [
      "fdwtt7"
    ],
    "reverseScore": true,
    "questionIndex": 92,
    "text": "I don't waste my time with the excessive demands of some clients.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "b3gy3j": {
    "id": "b3gy3j",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 293,
    "categoryId": 2,
    "scoredDimensions": [
      "g5ii0e"
    ],
    "reverseScore": true,
    "questionIndex": 93,
    "text": "I get angry when a client is rude to me.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "blaq6p": {
    "id": "blaq6p",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 295,
    "categoryId": 2,
    "scoredDimensions": [
      "eb2x38"
    ],
    "reverseScore": false,
    "questionIndex": 94,
    "text": "I win because I am more responsive than my competitors.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "w38a3o": {
    "id": "w38a3o",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 298,
    "categoryId": 2,
    "scoredDimensions": [
      "ltu5rt"
    ],
    "reverseScore": true,
    "questionIndex": 95,
    "text": "It makes me uncomfortable when people get emotional.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "siu60g": {
    "id": "siu60g",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 300,
    "categoryId": 2,
    "scoredDimensions": [
      "ceokld"
    ],
    "reverseScore": false,
    "questionIndex": 96,
    "text": "I feel an urgency to respond to clients' needs quickly.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "twqi4v": {
    "id": "twqi4v",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 301,
    "categoryId": 2,
    "scoredDimensions": [
      "oyzo55"
    ],
    "reverseScore": false,
    "questionIndex": 97,
    "text": "It is easy for me to relate to the feelings of my clients.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "kqqdwu": {
    "id": "kqqdwu",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 304,
    "categoryId": 3,
    "scoredDimensions": [
      "u0uvji"
    ],
    "reverseScore": true,
    "questionIndex": 98,
    "text": "When faced with a tough problem, I immediately call an expert.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "ep20yc": {
    "id": "ep20yc",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 306,
    "categoryId": 3,
    "scoredDimensions": [
      "d22k6w"
    ],
    "reverseScore": false,
    "questionIndex": 99,
    "text": "When something is not working, I can isolate the source of the problem.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "ywhlcw": {
    "id": "ywhlcw",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 309,
    "categoryId": 3,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 100,
    "text": "I am good with technology and proactive at finding the answers.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "zgnj20": {
    "id": "zgnj20",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 314,
    "categoryId": 3,
    "scoredDimensions": [
      "y93iyg"
    ],
    "reverseScore": false,
    "questionIndex": 101,
    "text": "I am motivated by the challenge of a complicated problem.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "i4nukl": {
    "id": "i4nukl",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 316,
    "categoryId": 3,
    "scoredDimensions": [
      "eb2x38"
    ],
    "reverseScore": true,
    "questionIndex": 102,
    "text": "I hate reading instructions to figure something out.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "u68kkx": {
    "id": "u68kkx",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 317,
    "categoryId": 3,
    "scoredDimensions": [
      "jrsl97"
    ],
    "reverseScore": false,
    "questionIndex": 103,
    "text": "I am constantly asking questions to better understand.",
    "status": "live",
    "dimensionFamily": "krqa3d"
  },
  "ovq39n": {
    "id": "ovq39n",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 318,
    "categoryId": 1,
    "scoredDimensions": [
      "qsptzl"
    ],
    "reverseScore": false,
    "questionIndex": 104,
    "text": "I have mastered the skills to accurately qualify opportunities.",
    "status": "live",
    "dimensionFamily": "zx6iaq"
  },
  "ma5nog": {
    "id": "ma5nog",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 319,
    "categoryId": 1,
    "scoredDimensions": [
      "jctmmw"
    ],
    "reverseScore": false,
    "questionIndex": 105,
    "text": "I have mastered how to align our sales process with the prospect's buying process.",
    "status": "live",
    "dimensionFamily": "bfbovn"
  },
  "hmzdee": {
    "id": "hmzdee",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 320,
    "categoryId": 1,
    "scoredDimensions": [
      "x47kw5"
    ],
    "reverseScore": false,
    "questionIndex": 106,
    "text": "I have mastered deal preparation skills to address buyer uncertainties.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "bq3dj4": {
    "id": "bq3dj4",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 325,
    "categoryId": 1,
    "scoredDimensions": [
      "xy680l"
    ],
    "reverseScore": false,
    "questionIndex": 107,
    "text": "I have mastered communication skills to build rapport with a prospective client.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "g3nc7o": {
    "id": "g3nc7o",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 326,
    "categoryId": 1,
    "scoredDimensions": [
      "x47kw5"
    ],
    "reverseScore": false,
    "questionIndex": 108,
    "text": "I deliver compelling sales presentations that motivate my buyer to action.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "wdn5r3": {
    "id": "wdn5r3",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 327,
    "categoryId": 1,
    "scoredDimensions": [
      "d22k6w"
    ],
    "reverseScore": false,
    "questionIndex": 109,
    "text": "I thoroughly understand the needs, fears, and accountabilities of my buyer.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "wmt4qj": {
    "id": "wmt4qj",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 330,
    "categoryId": 1,
    "scoredDimensions": [
      "b0e6f1"
    ],
    "reverseScore": false,
    "questionIndex": 110,
    "text": "I have mastered negotiating skills to manage objections and pricing tactics.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "xplax8": {
    "id": "xplax8",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 336,
    "categoryId": 1,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 111,
    "text": "I have mastered closing skills to address resistance and ask for commitment.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "cr6umk": {
    "id": "cr6umk",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 337,
    "categoryId": 1,
    "scoredDimensions": [
      "xy680l"
    ],
    "reverseScore": false,
    "questionIndex": 112,
    "text": "I successfully cultivate new business through my current client relationships.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "u9ago7": {
    "id": "u9ago7",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 339,
    "categoryId": 1,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 113,
    "text": "It is important to me that I regularly receive recognition for good work.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "v2yfxx": {
    "id": "v2yfxx",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 342,
    "categoryId": 1,
    "scoredDimensions": [
      "zbij77"
    ],
    "reverseScore": false,
    "questionIndex": 114,
    "text": "I seek a culture that rewards productivity at the individual level.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "tnorev": {
    "id": "tnorev",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 349,
    "categoryId": 1,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 115,
    "text": "I like to give feedback.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "jor2b4": {
    "id": "jor2b4",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 351,
    "categoryId": 1,
    "scoredDimensions": [
      "xmstja"
    ],
    "reverseScore": false,
    "questionIndex": 116,
    "text": "I like when others look to me to make tough decisions.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "k94634": {
    "id": "k94634",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 353,
    "categoryId": 1,
    "scoredDimensions": [
      "ceokld"
    ],
    "reverseScore": false,
    "questionIndex": 117,
    "text": "I like to make others successful.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "x197n0": {
    "id": "x197n0",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 354,
    "categoryId": 1,
    "scoredDimensions": [
      "b0e6f1"
    ],
    "reverseScore": false,
    "questionIndex": 118,
    "text": "I like to get people to say yes.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "yrftbc": {
    "id": "yrftbc",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 360,
    "categoryId": 1,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 119,
    "text": "I like solving other peoples' problems.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "jey4s3": {
    "id": "jey4s3",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 363,
    "categoryId": 1,
    "scoredDimensions": [
      "eb2x38"
    ],
    "reverseScore": false,
    "questionIndex": 120,
    "text": "I like to find ways to do more than what is expected of me.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "s9artk": {
    "id": "s9artk",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 371,
    "categoryId": 2,
    "scoredDimensions": [
      "g5ii0e"
    ],
    "reverseScore": false,
    "questionIndex": 121,
    "text": "My associates know they can rely on me when they are in a bind.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "vg5yvf": {
    "id": "vg5yvf",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 372,
    "categoryId": 2,
    "scoredDimensions": [
      "vjtt0z"
    ],
    "reverseScore": false,
    "questionIndex": 122,
    "text": "My clients and associates are among my closest friends.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "hrzxkm": {
    "id": "hrzxkm",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 373,
    "categoryId": 2,
    "scoredDimensions": [
      "xmstja"
    ],
    "reverseScore": true,
    "questionIndex": 123,
    "text": "I don't think I should have to contribute more than my fair share.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "tas14h": {
    "id": "tas14h",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 374,
    "categoryId": 2,
    "scoredDimensions": [
      "up7jjs"
    ],
    "reverseScore": false,
    "questionIndex": 124,
    "text": "I am constantly communicating to make sure everyone knows what's going on.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "fzrkkp": {
    "id": "fzrkkp",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 375,
    "categoryId": 2,
    "scoredDimensions": [
      "fdwtt7"
    ],
    "reverseScore": true,
    "questionIndex": 125,
    "text": "I look out for myself and expect others to do the same.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "rc0736": {
    "id": "rc0736",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 376,
    "categoryId": 2,
    "scoredDimensions": [
      "zbij77"
    ],
    "reverseScore": false,
    "questionIndex": 126,
    "text": "In the last seven days, I have worked extra hours to help a team member.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "df5j8b": {
    "id": "df5j8b",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 377,
    "categoryId": 2,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 127,
    "text": "I feel grateful for my team and the clients who I serve.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "rrtzu0": {
    "id": "rrtzu0",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 378,
    "categoryId": 2,
    "scoredDimensions": [
      "jctmmw"
    ],
    "reverseScore": true,
    "questionIndex": 128,
    "text": "In general, I don't feel like I have gotten what I deserve at work.",
    "status": "live",
    "dimensionFamily": "bfbovn"
  },
  "emwi7c": {
    "id": "emwi7c",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 380,
    "categoryId": 2,
    "scoredDimensions": [
      "b0e6f1"
    ],
    "reverseScore": false,
    "questionIndex": 129,
    "text": "I frequently thank my team and recognize them for outstanding work.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "ku8apl": {
    "id": "ku8apl",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 400,
    "categoryId": 3,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 130,
    "text": "Others know I will adapt and go with the flow.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "czcdlf": {
    "id": "czcdlf",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 401,
    "categoryId": 3,
    "scoredDimensions": [
      "itypp1"
    ],
    "reverseScore": true,
    "questionIndex": 131,
    "text": "I am a creature of habit who avoids change when possible.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "z2dlpz": {
    "id": "z2dlpz",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 405,
    "categoryId": 1,
    "scoredDimensions": [
      "xy680l"
    ],
    "reverseScore": false,
    "questionIndex": 132,
    "text": "It is very important to me that I am always improving.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "b0vomu": {
    "id": "b0vomu",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 857,
    "categoryId": 3,
    "scoredDimensions": [
      "zbij77"
    ],
    "reverseScore": false,
    "questionIndex": 133,
    "text": "I have a passion for financials and statistics.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "sm21j2": {
    "id": "sm21j2",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 858,
    "categoryId": 3,
    "scoredDimensions": [
      "p0ruta"
    ],
    "reverseScore": false,
    "questionIndex": 134,
    "text": "I like puzzles and mind games that make me think.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  },
  "lf6v3v": {
    "id": "lf6v3v",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 859,
    "categoryId": 1,
    "scoredDimensions": [
      "x3ycav"
    ],
    "reverseScore": false,
    "questionIndex": 135,
    "text": "At the end of a long day, I often feel energized when others are tired.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "joeil8": {
    "id": "joeil8",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 861,
    "categoryId": 1,
    "scoredDimensions": [
      "zavm2z"
    ],
    "reverseScore": false,
    "questionIndex": 136,
    "text": "I want to work for a business that measures and rewards results.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "gv5p2l": {
    "id": "gv5p2l",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1066,
    "categoryId": 3,
    "scoredDimensions": [
      "vjtt0z"
    ],
    "reverseScore": false,
    "questionIndex": 137,
    "text": "I am a pioneer, who leads innovation in my industry.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "p62fty": {
    "id": "p62fty",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1067,
    "categoryId": 3,
    "scoredDimensions": [
      "zbij77"
    ],
    "reverseScore": false,
    "questionIndex": 138,
    "text": "I modify my approach based upon my competition.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "cn5m6f": {
    "id": "cn5m6f",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1069,
    "categoryId": 3,
    "scoredDimensions": [
      "ep6tj6"
    ],
    "reverseScore": true,
    "questionIndex": 139,
    "text": "I become flustered when I have to adjust at the last minute.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "hhfy0l": {
    "id": "hhfy0l",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1070,
    "categoryId": 3,
    "scoredDimensions": [
      "t9sjaz"
    ],
    "reverseScore": true,
    "questionIndex": 140,
    "text": "In a sales presentation, I don't like to deviate from the agenda.",
    "status": "live",
    "dimensionFamily": "wbxc32"
  },
  "ire750": {
    "id": "ire750",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1071,
    "categoryId": 3,
    "scoredDimensions": [
      "d22k6w"
    ],
    "reverseScore": false,
    "questionIndex": 141,
    "text": "I see creative options to overcome my clients' obstacles.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "pi3wfz": {
    "id": "pi3wfz",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1101,
    "categoryId": 1,
    "scoredDimensions": [
      "vjtt0z"
    ],
    "reverseScore": false,
    "questionIndex": 142,
    "text": "My mom and/or dad made their living in sales.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "ny7zum": {
    "id": "ny7zum",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1102,
    "categoryId": 2,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 143,
    "text": "People open up and share things with me that they don't share with others.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "xw5mt5": {
    "id": "xw5mt5",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1103,
    "categoryId": 1,
    "scoredDimensions": [
      "jctmmw"
    ],
    "reverseScore": false,
    "questionIndex": 144,
    "text": "I was a highly active child.",
    "status": "live",
    "dimensionFamily": "bfbovn"
  },
  "j0sdr9": {
    "id": "j0sdr9",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1104,
    "categoryId": 2,
    "scoredDimensions": [
      "ceokld"
    ],
    "reverseScore": false,
    "questionIndex": 145,
    "text": "I ask my clients the important questions that my competitors fail to ask.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "ls1dxw": {
    "id": "ls1dxw",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1105,
    "categoryId": 1,
    "scoredDimensions": [
      "jrsl97"
    ],
    "reverseScore": true,
    "questionIndex": 146,
    "text": "I view myself as more of a consultant than a sales person.",
    "status": "live",
    "dimensionFamily": "krqa3d"
  },
  "rmdaf1": {
    "id": "rmdaf1",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1106,
    "categoryId": 1,
    "scoredDimensions": [
      "up7jjs"
    ],
    "reverseScore": false,
    "questionIndex": 147,
    "text": "As a competitive athlete, I endured major struggles in order to succeed.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "gfjt76": {
    "id": "gfjt76",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1107,
    "categoryId": 1,
    "scoredDimensions": [
      "busvn2"
    ],
    "reverseScore": false,
    "questionIndex": 148,
    "text": "Before age ten, I came up with an idea that involved selling to friends or neighbors.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "zrhkbs": {
    "id": "zrhkbs",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1108,
    "categoryId": 1,
    "scoredDimensions": [
      "enzx1e"
    ],
    "reverseScore": true,
    "questionIndex": 149,
    "text": "The risk of an entrepreneurial venture makes me uncomfortable.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "i28m9f": {
    "id": "i28m9f",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1109,
    "categoryId": 1,
    "scoredDimensions": [
      "g5ii0e"
    ],
    "reverseScore": true,
    "questionIndex": 150,
    "text": "I have learned to be a good loser.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "jj0voi": {
    "id": "jj0voi",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1110,
    "categoryId": 1,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": false,
    "questionIndex": 151,
    "text": "I perform better against a tough competitor.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "xk5z9t": {
    "id": "xk5z9t",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1111,
    "categoryId": 1,
    "scoredDimensions": [
      "t9sjaz"
    ],
    "reverseScore": true,
    "questionIndex": 152,
    "text": "I don't mind losing when I've played my best.",
    "status": "live",
    "dimensionFamily": "wbxc32"
  },
  "h5wqxo": {
    "id": "h5wqxo",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1112,
    "categoryId": 1,
    "scoredDimensions": [
      "up7jjs"
    ],
    "reverseScore": false,
    "questionIndex": 153,
    "text": "I prefer a job where most or all of my compensation is commission-based.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "pya3lr": {
    "id": "pya3lr",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1113,
    "categoryId": 1,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 154,
    "text": "I am afraid of falling behind.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "wjnm93": {
    "id": "wjnm93",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1114,
    "categoryId": 1,
    "scoredDimensions": [
      "jrsl97"
    ],
    "reverseScore": false,
    "questionIndex": 155,
    "text": "I want to be compared and ranked publicly against my competitor.",
    "status": "live",
    "dimensionFamily": "krqa3d"
  },
  "fim35o": {
    "id": "fim35o",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1115,
    "categoryId": 3,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 156,
    "text": "I accurately anticipate what will happen next in the sales cycle.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "pspeht": {
    "id": "pspeht",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1116,
    "categoryId": 3,
    "scoredDimensions": [
      "jrsl97"
    ],
    "reverseScore": true,
    "questionIndex": 157,
    "text": "I am often surprised by the way things work out.",
    "status": "live",
    "dimensionFamily": "krqa3d"
  },
  "q64cqt": {
    "id": "q64cqt",
    "questionFormat": "likert",
    "questionType": "talent",
    "legacyId": 1117,
    "categoryId": 2,
    "scoredDimensions": [
      "ceokld"
    ],
    "reverseScore": false,
    "questionIndex": 158,
    "text": "In the last week, I have introduced someone to a resource in my network.",
    "status": "live",
    "dimensionFamily": "z0m0xd"
  },
  "hg4q9y": {
    "id": "hg4q9y",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1118,
    "categoryId": 1,
    "scoredDimensions": [
      "up7jjs"
    ],
    "reverseScore": false,
    "questionIndex": 159,
    "text": "I use financial language to describe the impact our solution will have on my customer's business.",
    "status": "live",
    "dimensionFamily": "aof9jh"
  },
  "edrabi": {
    "id": "edrabi",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1119,
    "categoryId": 1,
    "scoredDimensions": [
      "d22k6w"
    ],
    "reverseScore": false,
    "questionIndex": 160,
    "text": "I effectively determine how the decision-making process will work for each sales opportunity.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "yhmztb": {
    "id": "yhmztb",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1120,
    "categoryId": 1,
    "scoredDimensions": [
      "fdwtt7"
    ],
    "reverseScore": false,
    "questionIndex": 161,
    "text": "I consistently apply data to meet and exceed sales targets.",
    "status": "live",
    "dimensionFamily": "f5yhku"
  },
  "ba5i1l": {
    "id": "ba5i1l",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1121,
    "categoryId": 1,
    "scoredDimensions": [
      "itypp1"
    ],
    "reverseScore": false,
    "questionIndex": 162,
    "text": "I communicate confidence in my team's ability to reach stretch targets for account acquisition and/or expansion.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "lkcpx6": {
    "id": "lkcpx6",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1122,
    "categoryId": 1,
    "scoredDimensions": [
      "y93iyg"
    ],
    "reverseScore": false,
    "questionIndex": 163,
    "text": "I effectively identify and gain access to the true influencers and decision makers for each account.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "w2txsl": {
    "id": "w2txsl",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1123,
    "categoryId": 1,
    "scoredDimensions": [
      "eb2x38"
    ],
    "reverseScore": false,
    "questionIndex": 164,
    "text": "I engage the best from my team and company resources when competing against a top contender in our space.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "gqq49x": {
    "id": "gqq49x",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1124,
    "categoryId": 1,
    "scoredDimensions": [
      "qsptzl"
    ],
    "reverseScore": false,
    "questionIndex": 165,
    "text": "I am able to handle objections to move sales conversations forward without ignoring real problems or irritating customers.",
    "status": "live",
    "dimensionFamily": "zx6iaq"
  },
  "trq72w": {
    "id": "trq72w",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1125,
    "categoryId": 1,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": false,
    "questionIndex": 166,
    "text": "I ask thoughtful, open-ended questions to gain a thorough understanding of each customer's situation and objectives.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "li5e5x": {
    "id": "li5e5x",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1126,
    "categoryId": 1,
    "scoredDimensions": [
      "enzx1e"
    ],
    "reverseScore": false,
    "questionIndex": 167,
    "text": "I raise my prospects' interest level in our company quickly.",
    "status": "live",
    "dimensionFamily": "zuv1zj"
  },
  "igompl": {
    "id": "igompl",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1127,
    "categoryId": 1,
    "scoredDimensions": [
      "busvn2"
    ],
    "reverseScore": false,
    "questionIndex": 168,
    "text": "I invest personal time and attention to build targeted and meaningful relationships to accelerate business opportunities.",
    "status": "live",
    "dimensionFamily": "atracy"
  },
  "m9ldjl": {
    "id": "m9ldjl",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1128,
    "categoryId": 1,
    "scoredDimensions": [
      "x3ycav"
    ],
    "reverseScore": false,
    "questionIndex": 169,
    "text": "My team would rate me as effective in providing performance feedback and deal coaching to improve their performance.",
    "status": "live",
    "dimensionFamily": "epac06"
  },
  "jfkk8u": {
    "id": "jfkk8u",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1130,
    "categoryId": 1,
    "scoredDimensions": [
      "jctmmw"
    ],
    "reverseScore": false,
    "questionIndex": 170,
    "text": "I clarify each team member's role and responsibility in delivering to customer needs.",
    "status": "live",
    "dimensionFamily": "bfbovn"
  },
  "view06": {
    "id": "view06",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1131,
    "categoryId": 1,
    "scoredDimensions": [
      "lc4930"
    ],
    "reverseScore": false,
    "questionIndex": 171,
    "text": "I am good at analyzing data to uncover untapped potential opportunites with customers.",
    "status": "live",
    "dimensionFamily": "b07r6p"
  },
  "y4037n": {
    "id": "y4037n",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1132,
    "categoryId": 1,
    "scoredDimensions": [
      "hp8cen"
    ],
    "reverseScore": false,
    "questionIndex": 172,
    "text": "I welcome opportunites to customize our offering to serve our customers' needs.",
    "status": "live",
    "dimensionFamily": "aviw3m"
  },
  "bueok7": {
    "id": "bueok7",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1133,
    "categoryId": 1,
    "scoredDimensions": [
      "qsptzl"
    ],
    "reverseScore": false,
    "questionIndex": 173,
    "text": "I demonstrate expert knowledge of how to differentiate our offering from our competition.",
    "status": "live",
    "dimensionFamily": "zx6iaq"
  },
  "k3w5nf": {
    "id": "k3w5nf",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1134,
    "categoryId": 1,
    "scoredDimensions": [
      "itypp1"
    ],
    "reverseScore": false,
    "questionIndex": 174,
    "text": "I seek creative solutions to address conflicts and resolve problems.",
    "status": "live",
    "dimensionFamily": "b62kuo"
  },
  "y4r69q": {
    "id": "y4r69q",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1135,
    "categoryId": 1,
    "scoredDimensions": [
      "qxgy0i"
    ],
    "reverseScore": false,
    "questionIndex": 175,
    "text": "I focus my time and resources on accounts with the highest business potential.",
    "status": "live",
    "dimensionFamily": "vz89qw"
  },
  "y7hc8y": {
    "id": "y7hc8y",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1136,
    "categoryId": 1,
    "scoredDimensions": [
      "zbij77"
    ],
    "reverseScore": false,
    "questionIndex": 176,
    "text": "I take accountability to follow up with internal team members on customer deliverables.",
    "status": "live",
    "dimensionFamily": "yhbcgm"
  },
  "ikez6g": {
    "id": "ikez6g",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1137,
    "categoryId": 1,
    "scoredDimensions": [
      "moo90r"
    ],
    "reverseScore": false,
    "questionIndex": 177,
    "text": "I am succcessful at achieving positive results from a negotiation while maintaining strong customer relationships.",
    "status": "live",
    "dimensionFamily": "zx07x6"
  },
  "kzjcur": {
    "id": "kzjcur",
    "questionFormat": "likert",
    "questionType": "skill",
    "legacyId": 1138,
    "categoryId": 1,
    "scoredDimensions": [
      "x47kw5"
    ],
    "reverseScore": false,
    "questionIndex": 178,
    "text": "I am good at planning carefully in advance to anticipate and address future customer needs.",
    "status": "live",
    "dimensionFamily": "lrakq9"
  }
}



// WEBPACK FOOTER //
// ./src/data/questions.js